import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Book } from './book.model';
import { JournalEntry } from '../../journal-entries/state/journal-entry.model';

export interface BooksState extends EntityState<Book>, ActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'books' })
export class BooksStore extends EntityStore<BooksState> {
    constructor() {
        super();
    }

    akitaPreAddEntity(book: Book) {
        return {
            ...book,
            ownerId: +book.ownerId
        };
    }
}
